import React, { useContext, useEffect, useState, useRef } from 'react';
import { Link, useNavigate } from 'react-router-dom';
// import { useTranslation } from "react-i18next";
import { ShopperContext } from '../context/shopper';
import { usePhrasing } from "../hooks/useSkuUtils";
import { useUtils } from "../hooks/useUtils";
import { findAbsAmtAsPct } from '../utils';
export const SkuMenuLink = ( {sku, trip,
                          // countOfPlus,
                          showZeroOutSku, incrementPlus, decrementPlus } ) => {
  const { shopper, circleShoppers, orderItems, addOrderItem,
    dismissErrorsList, setErrorsDoExistToFalse, setJustGotClearToFalse,
  } = useContext(ShopperContext);
  //console.log("spl shopper", shopper)
  console.log("orderItemsSPL do_me", orderItems)
  //console.log("spl sku", sku)
  //console.log("spl trip", trip)

  const navigate = useNavigate();

  // initialize with first pattern element we show, hardcoded here:
  const [pattern, setPattern] = useState('*__');
  const [addOiInProgress, setAddOiInProgress] = useState(false);
  const [count, setCount] = useState(0);

  const { weightAndUnitsOfSku } = usePhrasing();
  const { shoppers_order_for_this_sku_this_trip, getSpinString,
          is_shopper_a_circle_admin } = useUtils();
  // const { t } = useTranslation();

  const if_shopper_is_circle_admin = is_shopper_a_circle_admin({
    cShoppers: circleShoppers, circle_id: trip.circle.id, shopper_id: shopper.id
  });

  // With each SkuMenuLink we see if the shopper already has a matching
  // orderItem for a given sku of the circle for this trip.
  //console.log('skulink circles', circles)
  const matchingOrder = shoppers_order_for_this_sku_this_trip({
    oItems: orderItems,
    shopper_id: shopper.id,
    sku_id: sku.id,
    trip_id: trip.id
  })
  console.log('matchingOrderM do_me', shopper.id, sku.id, trip.id, matchingOrder)

  useEffect(() => {
    if (matchingOrder === undefined) {
      incrementPlus();
    }
  }, []);
  // Only run this once, i.e. don't change the dependency array without reason.
  // Together with any other 'SkuMenuLink' components that do 'incrementPlus',
  // we'll know how many plus signs were in effect upon first showing the
  // Maybe-List. We'll decrement this count upon each click of a '+'. When it
  // hits zero, we'll stop showing the message advising to "Click the '+' sign."

  // useEffect(() => {
  //   console.log('cop count', countOfPlus
  //     // , sku.id
  //   );
  // }, [countOfPlus
  //   // , sku
  //   ]);

  const timerIdRef = useRef(null);
  
  useEffect(() => {
    if(addOiInProgress){
      timerIdRef.current = setTimeout(() => {
        setPattern( getSpinString({place: count}) );
        setCount((prevCount) => prevCount + 1);
      }, 300);
      // It doesn't matter that we bump 'count' afterwards.
      // It changes, so the pattern that we show will look different next time.
    }
    
    // Not comfortable with this. Who/what is listening for a 'return'?
    // I've copied this code from
// https://learnersbucket.com/examples/interview/increment-counter-component-in-react/
    // and the sample code did not include 'return'.
    // But vscode shows errors. And, including 'return' seems to fix them.

    return () => {
      clearTimeout(timerIdRef.current);
    }
  }, [count, addOiInProgress, getSpinString])

  // TODO: If this is needed, why not do it earlier?
  if (sku) {
  console.log('skulink skuXY', sku)
  } else {
    return
  }

  // The shopper has clicked the '+' button to add the sku to the circle's
  // shopping list since the orderItems state variable in Context had no match
  // for the shopper, sku and trip. We will add orderItem records with
  // abs_amount set to zero for this sku for each shopper in the circle.
  const handleClick = ({sku, trip}) => {
    console.log("spl hc sku", sku);
    console.log("spl hc trip", trip);
    const initialAbsAmt = 0;

    // decrement the count of 'plus' signs by one:
    decrementPlus();

    // clear out any error messages, success statuses
    dismissErrorsList();
    setErrorsDoExistToFalse();
    setJustGotClearToFalse();

    circleShoppers.filter(cs => cs.circle_id == trip.circle.id ).forEach(cs => {
        const orderItem = {
          shopper_id: cs.shopper_id,
          // the Rails 'create' action should verify that cs.shopper_id is in this
          // current_shopper's circle

          sku_id: sku.id,
          trip_id: trip.id,
          abs_amount: initialAbsAmt
        };
        console.log("orderItemP", orderItem)
        setAddOiInProgress(true);
        (async function () {
          try {
          await addOrderItem(orderItem);
          } catch (error) {
            console.error(error);
          } finally {
            clearTimeout(timerIdRef.current);
            setAddOiInProgress(false);
          }
        })();
        console.log("orderItemsY", orderItems)
    })
  }

  async function removeSkuOrders(tripId, skuId) {
    const response = await fetch(`/api/trips/${tripId}/reset_trip_sku`, {
      method: 'DELETE',
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ sku_id: skuId }),
    });
  
    // Check if the response was successful (status in 2xx range)
    if (!response.ok) {
      // Handle non-successful responses (e.g., 4xx or 5xx errors)
      // We might still try to parse JSON here if the server sends
      // error details in JSON
      // e.g. API might return 'unprocessable_content' error.
      // TODO: improve/standardize error handling here.
      const errorData = await response.json().catch(
                              () => ({ message: 'An unknown error occurred' }));
      console.error('Error removing SKU order:', response.status, errorData);
      throw new Error(errorData.message || `Server error: ${response.status}`);
    }

    // Check if the response has content before trying to parse it as JSON
    // A 204 No Content response, for example, will not have a body.
    if (response.status !== 204 && response.headers.get('content-length') > '0') {
      const data = await response.json();
      console.log(data);
    } else {
      console.log('Sku order(s) removed successfully, no content in response.');
      incrementPlus();
      navigate(-1);
      navigate(0);
      // TODO: get this to work:
      // navigate(`/trips/${trip.id}`, {replace: true});
      // i.e., now that the Sku has no orderItems for the Trip, the value at
      // the left should turn into '+' and the space with the 'X' into '--'.
      // We shouldn't have to leave this view and come back just to refresh.
      // Need to rebuild 'skusList' in 'SkuMenu'.
    }
  }

  // checkbox advice per https://www.robinwieruch.de/react-checkbox/
  // button advice per https://www.robinwieruch.de/react-button/
  // https://upmostly.com/tutorials/pass-a-parameter-through-onclick-in-react
  return (
    <tr>
      <td>
        { matchingOrder === undefined
            ? <button
                type="button"
                disabled={addOiInProgress}
                onClick={() => handleClick({sku,trip})}
              >
                { addOiInProgress ? pattern : '+' }
              </button>
            : (
              matchingOrder.sku.type == 'WeightyItem'
                ? Math.trunc( matchingOrder.abs_amount * 100
                    / (matchingOrder.sku.typical_weight || 1) ).toString() + "%"
                : matchingOrder.sku.type == 'MultipackItem'
                  ? Math.trunc( 
                      findAbsAmtAsPct({
                        topNum: matchingOrder.abs_amount,
                        sku: matchingOrder.sku
                      })
                              ).toString() + "%"
                  : Math.trunc( matchingOrder.abs_amount * 100).toString() + "%"
              )
        }
      </td>

      {if_shopper_is_circle_admin && showZeroOutSku &&
        <td>
          { matchingOrder === undefined
            ? '--'
            : <button type="button" onClick={ () => removeSkuOrders(trip.id, sku.id)}>
                {'X'}
              </button>
          }
        </td>
      }

      <td>
        {sku.brand}
      </td>

      <td>
        <Link to={`/skus/${sku.id}`}>
          {sku.label}
        </Link>
        {
          weightAndUnitsOfSku({
            sku,
            showWeightAsTswEditLink: false,
            showUnitCount: true
          })
        }
      </td>

      <td>
        {sku.store_label}
      </td>

    </tr>
  )
}
      // {/* FIX ME: And have a link to the associated Order-Item table? */}

export default SkuMenuLink
